











import Vue from "vue";
import { UserInfo } from "../../interfaces";
import { getProfile } from "../../services";
export default Vue.extend({
  name: "app-home",
  data: () => ({
    user: undefined as UserInfo | undefined,
  }),
  async created() {
    this.user = await getProfile();
  },
});
